var map = {
	"./logo-anahuac.png": 101,
	"./logo-blanco-unab.png": 102,
	"./logo-error-home.png": 103,
	"./logo-error.png": 104,
	"./logo-ilernia.png": 105,
	"./logo-jormat-home.png": 106,
	"./logo-jormat.png": 107,
	"./logo-parvulo-head.png": 108,
	"./logo-parvulo-home.png": 109,
	"./logo-parvulo-pass.png": 110,
	"./logo-parvulo-white.png": 111,
	"./logo-parvulo.png": 112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/logo\-.*\.png$
// module id = 100
// module chunks = 0